import { render, staticRenderFns } from "./innmelding.vue?vue&type=template&id=7f8a65d4&scoped=true"
import script from "./innmelding.vue?vue&type=script&lang=js"
export * from "./innmelding.vue?vue&type=script&lang=js"
import style0 from "./innmelding.vue?vue&type=style&index=0&id=7f8a65d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8a65d4",
  null
  
)

export default component.exports